import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';


const VetrinaTab = ({ store }) => {
  return (
    <div className="space-y-6 md:space-y-8 lg:space-y-10">
      <section className="bg-card rounded-lg md:rounded-xl lg:rounded-2xl p-4 md:p-6 lg:p-8 shadow-warm">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground mb-4 md:mb-6">
          Chi Siamo
        </h2>
        <p className="text-sm md:text-base lg:text-lg text-foreground leading-relaxed whitespace-pre-line">
          {store?.description}
        </p>
      </section>
      <section className="bg-card rounded-lg md:rounded-xl lg:rounded-2xl p-4 md:p-6 lg:p-8 shadow-warm">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground mb-4 md:mb-6">
          Galleria
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 lg:gap-6">
          {store?.gallery?.map((item, index) => (
            <div
              key={index}
              className="relative aspect-square rounded-lg md:rounded-xl overflow-hidden bg-muted group cursor-pointer"
            >
              <Image
                src={item?.image}
                alt={item?.imageAlt}
                className="w-full h-full object-cover transition-smooth group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-foreground/0 group-hover:bg-foreground/20 transition-smooth" />
            </div>
          ))}
        </div>
      </section>
      <section className="bg-card rounded-lg md:rounded-xl lg:rounded-2xl p-4 md:p-6 lg:p-8 shadow-warm">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground mb-4 md:mb-6">
          Orari di Apertura
        </h2>
        {typeof store?.openingHours === 'string' ? (
          // Plain text format
          <p className="text-sm md:text-base text-foreground whitespace-pre-line leading-relaxed">
            {store?.openingHours}
          </p>
        ) : Array.isArray(store?.openingHours) && store?.openingHours?.length > 0 ? (
          // Structured array format
          <div className="space-y-3 md:space-y-4">
            {store?.openingHours?.map((schedule, index) => (
              <div
                key={index}
                className="flex items-center justify-between py-3 border-b border-border last:border-0"
              >
                <span className="text-sm md:text-base font-caption font-semibold text-foreground">
                  {schedule?.day}
                </span>
                <span className={`text-sm md:text-base font-caption ${
                  schedule?.closed ? 'text-destructive' : 'text-muted-foreground'
                }`}>
                  {schedule?.closed ? 'Chiuso' : schedule?.hours}
                </span>
              </div>
            ))}
          </div>
        ) : (
          // No hours available
          <p className="text-sm md:text-base text-muted-foreground italic">
            Orari non disponibili
          </p>
        )}
      </section>
      <section className="bg-card rounded-lg md:rounded-xl lg:rounded-2xl p-4 md:p-6 lg:p-8 shadow-warm">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground mb-4 md:mb-6">
          Contatti
        </h2>
        <div className="space-y-4 md:space-y-5 lg:space-y-6">
          <div className="flex items-start gap-3 md:gap-4">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="MapPin" size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs md:text-sm font-caption text-muted-foreground mb-1">
                Indirizzo
              </p>
              <p className="text-sm md:text-base lg:text-lg text-foreground">
                {store?.address}
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3 md:gap-4">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Phone" size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs md:text-sm font-caption text-muted-foreground mb-1">
                Telefono
              </p>
              <a
                href={`tel:${store?.phone}`}
                className="text-sm md:text-base lg:text-lg text-primary hover:underline"
              >
                {store?.phone}
              </a>
            </div>
          </div>

          <div className="flex items-start gap-3 md:gap-4">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Mail" size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs md:text-sm font-caption text-muted-foreground mb-1">
                Email
              </p>
              <a
                href={`mailto:${store?.email}`}
                className="text-sm md:text-base lg:text-lg text-primary hover:underline break-all"
              >
                {store?.email}
              </a>
            </div>
          </div>

          {store?.website && (
            <div className="flex items-start gap-3 md:gap-4">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name="Globe" size={20} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs md:text-sm font-caption text-muted-foreground mb-1">
                  Sito Web
                </p>
                <a
                  href={store?.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm md:text-base lg:text-lg text-primary hover:underline break-all"
                >
                  {store?.website}
                </a>
              </div>
            </div>
          )}
        </div>
      </section>
      <section className="bg-card rounded-lg md:rounded-xl lg:rounded-2xl p-4 md:p-6 lg:p-8 shadow-warm">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground mb-4 md:mb-6">
          Posizione
        </h2>
        <div className="w-full h-64 md:h-80 lg:h-96 rounded-lg md:rounded-xl overflow-hidden">
          <iframe
            width="100%"
            height="100%"
            loading="lazy"
            title={store?.name}
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps?q=${store?.coordinates?.lat},${store?.coordinates?.lng}&z=15&output=embed`}
          />
        </div>
      </section>
    </div>
  );
};

export default VetrinaTab;